var swiper = new Swiper(".swiperBanner", {
  navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
  },
  slidesPerView: 1.0001,
  centeredSlides: true,
  loop: true,
  autoplay: jQuery(".swiperBanner").data("autoplay") <= 0 ? false : { delay: parseInt(jQuery(".swiperBanner").data("autoplay")) }
});
var swiper1 = new Swiper(".swiper-3-col", {
  navigation: {
      nextEl: ".swiper-button-next-3-col",
      prevEl: ".swiper-button-prev-3-col",
  },
  slidesPerView: 1,
  spaceBetween: 30,
  loop: true,
  breakpoints: {
    480: {
      slidesPerView: 2,
      spaceBetween: 30
    },
    576: {
      slidesPerView: 3,
      spaceBetween: 100
    },

  }
});
var swiper2 = new Swiper(".swiper-4-col", {
  navigation: {
      nextEl: ".swiper-button-next-4-col",
      prevEl: ".swiper-button-prev-4-col",
  },
  slidesPerView: 1,
  spaceBetween: 30,
  slidesPerGroup: 1,
  breakpoints: {
    480: {
      slidesPerView: 2,
      spaceBetween: 30
    },
    640: {
      slidesPerView: 4,
      spaceBetween: 60,
    }
  }
});

